var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inline-editor",staticStyle:{"width":"90vw","height":"600px"}}),_vm._v(" "),_c('p',[_c('img',{staticClass:"inline-result",attrs:{"src":"","alt":""}})])])
}]

export { render, staticRenderFns }